import { OwlRepository, RdfTriplet } from './OwlActions'

const OWL_THING = "http://www.w3.org/2002/07/owl#Thing";
const OWL_CLASS = "http://www.w3.org/2002/07/owl#Class";

const getBindingValue = (binding, field) => {
    return binding && binding[field] ? binding[field].value : undefined;
};

const lastIriPart = (iri) => {
    if (!iri) return "";
    const hashIndex = iri.lastIndexOf("#");
    const slashIndex = iri.lastIndexOf("/");
    const index = Math.max(hashIndex, slashIndex);
    return index >= 0 ? iri.substring(index + 1) : iri;
};

const pushUnique = (values, value) => {
    if (value && values.indexOf(value) < 0)
        values.push(value);
};

const labelFromDetails = (details) => {
    const ru = details.labels.find(label => label.lang === "ru");
    if (ru) return ru.value;
    const empty = details.labels.find(label => !label.lang);
    if (empty) return empty.value;
    return details.labels.length > 0 ? details.labels[0].value : lastIriPart(details.iri);
};

const makeTreeFromBindings = (bindings, options) => {
    const idField = options.idField;
    const parentField = options.parentField;
    const rootIri = options.rootIri;
    const details = {};
    const nodes = {};

    const getDetails = (iri) => {
        if (!details[iri]) {
            details[iri] = {
                iri,
                label: lastIriPart(iri),
                labels: [],
                types: [],
                parents: [],
                children: [],
                domains: [],
                ranges: [],
                bindings: [],
            };
        }
        return details[iri];
    };

    const getNode = (iri) => {
        if (!nodes[iri]) {
            const itemDetails = getDetails(iri);
            nodes[iri] = {
                key: iri,
                iri,
                title: itemDetails.label,
                label: itemDetails.label,
                children: [],
                details: itemDetails,
            };
        }
        return nodes[iri];
    };

    (bindings || []).forEach(binding => {
        const iri = getBindingValue(binding, idField);
        if (!iri) return;

        const parent = getBindingValue(binding, parentField);
        const type = getBindingValue(binding, "type");
        const label = binding.label;
        const domain = getBindingValue(binding, "domain");
        const range = getBindingValue(binding, "range");
        const itemDetails = getDetails(iri);

        itemDetails.bindings.push(binding);
        pushUnique(itemDetails.types, type);
        pushUnique(itemDetails.parents, parent);
        pushUnique(itemDetails.domains, domain);
        pushUnique(itemDetails.ranges, range);

        if (label) {
            const isKnownLabel = itemDetails.labels.some(item => item.value === label.value && item.lang === label["xml:lang"]);
            if (!isKnownLabel)
                itemDetails.labels.push({value: label.value, lang: label["xml:lang"]});
        }

        itemDetails.label = labelFromDetails(itemDetails);
        const node = getNode(iri);
        node.title = itemDetails.label;
        node.label = itemDetails.label;
        node.parent = parent;
        node.type = type;

        if (parent)
            getNode(parent);
    });

    if (rootIri && Object.keys(nodes).length > 0) {
        const rootDetails = getDetails(rootIri);
        rootDetails.label = options.rootLabel || rootDetails.label;
        (options.rootTypes || []).forEach(type => pushUnique(rootDetails.types, type));

        const rootNode = getNode(rootIri);
        rootNode.title = rootDetails.label;
        rootNode.label = rootDetails.label;

        Object.keys(nodes).forEach(iri => {
            const node = nodes[iri];
            if (iri === rootIri || node.parent) return;
            node.parent = rootIri;
            node.implicitParent = true;
            pushUnique(node.details.parents, rootIri);
        });
    }

    const hasParentInPath = (parentIri, childIri) => {
        let current = parentIri;
        const visited = [];
        while (current && nodes[current] && visited.indexOf(current) < 0) {
            if (current === childIri) return true;
            visited.push(current);
            current = nodes[current].parent;
        }
        return false;
    };

    Object.keys(nodes).forEach(iri => {
        const node = nodes[iri];
        if (!node.parent || !nodes[node.parent]) return;
        if (node.parent === node.iri || hasParentInPath(node.parent, node.iri)) return;
        const parent = nodes[node.parent];
        if (!parent.children.some(child => child.key === node.key))
            parent.children.push(node);
        pushUnique(parent.details.children, node.iri);
        node.hasTreeParent = true;
    });

    const tree = Object.keys(nodes)
        .map(iri => nodes[iri])
        .filter(node => !node.hasTreeParent)
        .sort((a, b) => a.title.localeCompare(b.title));

    Object.keys(nodes).forEach(iri => {
        nodes[iri].children.sort((a, b) => a.title.localeCompare(b.title));
    });

    return {
        tree,
        list: Object.keys(details).map(iri => details[iri]).sort((a, b) => a.label.localeCompare(b.label)),
        details,
    };
};

/** Описание элементов в OWL 
 * description содержит информацию о графах. Для элементов графа фиксируется триплет
*/

const initialVOwlState = {
    load: false,
    description: [],
    classTree: [],
    propertyTree: [],
    classes: [],
    properties: [],
    classDetails: {},
    propertyDetails: {},
    treeElementDetails: {},
    selectedTreeElement: undefined,
}
export const vowl = (state = { ...initialVOwlState} , action) => {
    switch (action.type) {
        case "OwlRepository.EMPTY":
            return{
                ...initialVOwlState,
                load: true
            };
        case "OwlRepository.LOAD_STARTED":
            return{
                ...state,
                load: true
            };
        case "OwlRepository.LOAD_ERROR":
            return {
                ...initialVOwlState,
                error: action.error
            };
        case "OwlRepository.LOAD_LABELS":
            const n = [... state.description];
            let isExist = false;
            for (let i=0; i<n.length; i++) {
                if (isExist) break;
                const graph = n[i];
                if (graph.iri !== action.graph) continue;
                //Дальше смотрим только триплеты 
                if ((graph.subjects)&& Array.isArray(graph.subjects)){
                    for (let j=0; j<graph.subjects.length; j++) {
                        const subject = graph.subjects[j];
                        if (subject.iri == action.iri){
                            graph.subjects[j].values = action.values;
                            isExist = true;
                            break;
                        }
                    }
                    if (!isExist){
                        const s = {iri:action.iri, values:action.values};
                        graph.subjects.push(s);
                        isExist = true;
                        break;
                }
                }
            }
            if (!isExist){
                const g = {iri: action.graph};
                g.subjects=[{iri:action.iri, values:action.values}];
                n.push(g);
            }
            return {
                ...state,
                description: n,
            };

        case "OwlRepository.LOAD_DESCRIPTIONS":
            const nd = [... state.description];
            return {
                ...state,
                description: nd,
            };

        case "OwlRepository.LOAD_CLASS_TREE":
            const classData = makeTreeFromBindings(action.bindings, {
                idField: "class",
                parentField: "parent",
                rootIri: OWL_THING,
                rootLabel: "Thing",
                rootTypes: [OWL_CLASS],
            });
            return {
                ...state,
                load: false,
                graph: action.graph,
                classHead: action.head,
                classDistinct: action.distinct,
                classOrdered: action.ordered,
                classBindings: action.bindings,
                classTree: classData.tree,
                classes: classData.list,
                classDetails: classData.details,
            };

        case "OwlRepository.LOAD_PROPERTY_TREE":
            const propertyData = makeTreeFromBindings(action.bindings, {
                idField: "property",
                parentField: "parent",
            });
            return {
                ...state,
                load: false,
                graph: action.graph,
                propertyHead: action.head,
                propertyDistinct: action.distinct,
                propertyOrdered: action.ordered,
                propertyBindings: action.bindings,
                propertyTree: propertyData.tree,
                properties: propertyData.list,
                propertyDetails: propertyData.details,
            };

        case "OwlRepository.LOAD_TREE_ELEMENT_DETAILS":
            const treeElementDetails = {
                iri: action.iri,
                graph: action.graph,
                head: action.head,
                distinct: action.distinct,
                ordered: action.ordered,
                bindings: action.bindings,
                outgoing: (action.bindings || []).filter(item => item.direction && item.direction.value === "out"),
                incoming: (action.bindings || []).filter(item => item.direction && item.direction.value === "in"),
            };
            const classDetails = {...state.classDetails};
            const propertyDetails = {...state.propertyDetails};
            if (classDetails[action.iri])
                classDetails[action.iri] = {...classDetails[action.iri], details: treeElementDetails};
            if (propertyDetails[action.iri])
                propertyDetails[action.iri] = {...propertyDetails[action.iri], details: treeElementDetails};
            return {
                ...state,
                load: false,
                selectedTreeElement: action.iri,
                treeElementDetails: {
                    ...state.treeElementDetails,
                    [action.iri]: treeElementDetails,
                },
                classDetails,
                propertyDetails,
            };

        case "OwlRepository.SELECT_TREE_ELEMENT":
            return {
                ...state,
                selectedTreeElement: action.iri,
            };

        default:
            return state;
    }
}

/** Описание выбранного триплета. Элемент используется для создания, модификации (включая перевод)
 * и удаления.
 */
const initialVSelectedState = {
    execution: false,               //Состояние выполнении операции    
    operation: "view",              //Вид операции
    subject:   undefined,           //Субъект
    predicat: undefined,            //Значение предиката
    value:  undefined,              //Текущее или новое значение (object)
    previous: undefined,            //Предыдущее значение (для операций редактирования, удаления)
}
export const vselected = (state = { ...initialVSelectedState} , action) => {
  switch (action.type) {
    case "RdfTriplet.EMPTY":
      return{
        ...initialVSelectedState,
      };
    case "RdfTriplet.ERROR":
      return{
        ...state,
        error:  action.error
    };
    case "RdfTriplet.SELECTED":
      return{
        ...state,
        operation: action.operation,
        subject:   action.subject,
        predicat: action.predicat,
        value:  action.value
    };
    default:
      return state;
  }
}

/** Описание таксономии на основе SKOS. Используется для отображения фильтров */
const initialVTaxonomy = {
    taxonomy: [],           //Список такосономий
}

/** Описание списка субъектов */
const initialSubjects = {
    state: "empty",         //Состояние загрузки списка субъектов
    rfilter: [],            //Обязательный фильтр, который накладывается для отбора элементов
    conditions: [],         //Массив условий отбора
    offset: 0,
    limit: 10,
    count: -1,              //Всего количество элементов. -1 данные по количеству не загружены.
    head: {"link": [], "vars": ["IRI", "dsn", "dsv"]},
    distinct: false,
    ordered: true,
    detail: {},             //Информация о субъекте
    subjects: [],           //Список полученных субъектов в результате отбора
};

export const subjects = (state = { ...initialSubjects} , action) => {
    switch (action.type) {
        case "SubjectRepository.EMPTY": 
            return{
                ...initialSubjects,
                state: "empty"
            }
        case "SubjectRepository.SET_RFILTER": 
            return{
                ...state,
                rfilter: action.rfiter,
                state: "empty",
                assets: [],
            }            
        case "SubjectRepository.LOAD_STARTED": 
            return{
                ...state,
                state: "load"
            }
        case "SubjectRepository.LOAD_ERROR": 
            return {
                ...state,
                state: "error",
                error: action.error
            };            
        case "SubjectRepository.LOAD_DETAILS":
            return {
                ...state,
                detail: {
                    iri: action.iri,
                    values: action.values,
                    head: action.head, 
                    predicates: action.predicates, 
                    languages: action.languages,
                },
                state: "loaded"
            };
        case "SubjectRepository.LOAD_SUBJECTS": 
            return {
                ...state,
                offset: action.offset, 
                limit: action.limit, 
                count: action.count, 
                head: action.head, 
                distinct: action.distinct, 
                ordered: action.ordered, 
                subjects: action.subjects,
                state: "loaded",
            };
        case "SubjectRepository.LOAD_NEXTSUBJECTS": 
            return {
                ...state,
                offset: action.offset, 
                limit: action.limit, 
                head: action.head, 
                distinct: action.distinct, 
                ordered: action.ordered, 
                subjects: [...state.subjects, ...action.subjects],
                state: "loaded",
            };
        case "SubjectRepository.LOAD_DESCRIPTION":
            const nadesc = (state.subjects)?[...state.subjects]: [];
            for (let i=0; i<nadesc.length; i++) {
                const nadesc_a = nadesc[i];
                if ((nadesc_a.IRI) && (nadesc_a.IRI.value==action.IRI)){
                    nadesc_a.description = action.description;
                    //Если в отбор попадают с IRI дубликатами, то повторно вызывается загрузка описания
                    //break;
                }
            }
            return{
                ...state,
                subjects: nadesc,
            }
        default:
            return state;
    }
};
